import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import {
  ChannelReviewsResponse,
  ChannelRentalAVGRatingItem,
  getChannelMaxRating,
  getChannelReviewSource,
} from '@tokeet-frontend/reviews'
import { isEmptyTable } from '@tokeet-frontend/tv3-platform'
import { RentalReviewInsightsDialogService } from '../../components/rental-review-insights-dialog/rental-review-insights-dialog.dialog.service'

@Component({
  selector: 'app-rental-avg-rating',
  templateUrl: './rental-avg-rating.component.html',
  styleUrls: ['./rental-avg-rating.component.scss'],
})
export class RentalAvgRatingComponent implements OnInit {
  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }
  @ViewChild(MatSort) set sort(s: MatSort) {
    this.dataSource.sort = s
  }

  displayedColumns = [
    'rentalId',
    'latestReview.submittedAt',
    'averageOverallRating',
    'source',
    'latestReview.text',
    'insights',
  ]

  dataSource = new MatTableDataSource<ChannelRentalAVGRatingItem>()
  isEmpty$ = isEmptyTable(this.dataSource)

  @Input() set data(d: ChannelReviewsResponse) {
    this.dataSource.data = d?.rentalAverageOverallRating || []
  }

  @Input() isLoading = false

  constructor(private rentalReviewInsightsDialogService: RentalReviewInsightsDialogService) {}

  ngOnInit(): void {}

  onInsights(item: ChannelRentalAVGRatingItem) {
    this.rentalReviewInsightsDialogService.open({
      rentalId: item.rentalId,
      rentalAverageOverallRating: [item],
    })
  }

  maxRating(item: ChannelRentalAVGRatingItem) {
    return getChannelMaxRating(getChannelReviewSource(item.source))
  }
}
